<div class="PnSpinner">
  <div class="PnSpinner-inner"></div>
</div>
